export const seatStatuses = {
  7219: true,
  7220: true,
  7221: true,
  7222: true,
  7223: true,
  7224: true,
  7225: true,
  7226: true,
  7227: false,
  7228: false,
  7229: false,
  7230: false,
  7231: false,
  7232: false,
  7233: false,
  7241: true,
  7242: true,
  7243: true,
  7244: true,
  7245: true,
  7246: true,
  7247: true,
  7248: true,
  7249: true,
  7250: true,
  7251: false,
  7252: false,
  7253: true,
  7254: false,
  7255: false,
  7299: true,
  7300: true,
  7301: true,
  7302: true,
  7303: true,
  7304: true,
  7305: true,
  7306: true,
  7307: true,
  7308: true,
  7309: true,
  7310: true,
  7311: false,
  7312: true,
  7313: true,
  7321: true,
  7322: true,
  7323: false,
  7324: true,
  7325: true,
  7326: true,
  7327: false,
  7328: true,
  7329: true,
  7330: true,
  7331: true,
  7332: true,
  7333: true,
  7334: true,
  7335: true,
  7379: true,
  7380: true,
  7381: true,
  7382: true,
  7383: true,
  7384: true,
  7385: true,
  7386: true,
  7387: true,
  7388: true,
  7389: true,
  7390: true,
  7391: true,
  7392: false,
  7393: false,
  7401: true,
  7402: true,
  7403: true,
  7404: true,
  7405: true,
  7406: true,
  7407: true,
  7408: true,
  7409: true,
  7410: true,
  7411: true,
  7412: true,
  7413: true,
  7414: true,
  7415: true
};
